<template>
  <div class="is-flex is-align-items-center is-justify-content-space-between is-full py-1">
    <span
      v-if="isText"
      class="mr-2"
    >
      <span v-if="showLabel">
        {{ label }}
      </span>
      <span v-else-if="value !== null && value !== undefined && value !== ''">
        {{ value }}
      </span>
      <span v-else>
        -
      </span>
    </span>

    <!-- Empty values always show the same "-" placeholder -->
    <div
      v-if="isHtml && value"
      class="py-2 is-rich-text"
      v-html="value"
    />
    <span v-else-if="isHtml">
      -
    </span>

    <div v-if="isLink">
      <a
        v-if="showLink(value)"
        :href="value"
        :target="target"
      >
        {{ label }}
      </a>
      <span v-else>
        -
      </span>
    </div>

    <div v-if="isMoney">
      <span v-if="value">
        {{ value }}
        <span class="currency">
          {{ $laravel.currencies.cad.symbol }}
        </span>
      </span>
      <span v-else>
        -
      </span>
    </div>

    <span v-if="isDate">
      <span v-if="value">
        {{
          $dayjs(value)
            .utc()
            .format("LL")
        }}
      </span>
      <span v-else>
        -
      </span>
    </span>

    <slot name="custom" />

    <button
      v-if="isUpdateMode && canEdit"
      class="button is-white is-small"
      @click="openFieldModal"
    >
      <span class="icon">
        <i class="mdi mdi-pencil mdi-14px" />
      </span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      required: true,
      type: String,
    },
    field: {
      required: true,
      type: String,
    },
    value: {
      default:  null,
      type: [String ,Number, null, Boolean, Object, Array],
    },
    property: {
      default: null,
      type: Object,
    },
    mode: {
      default: "update",
      type: String,
    },
    type: {
      default: "text",
      type: String,
    },
    showLabel: {
      default: false,
      type: Boolean,
    },
    canEdit: {
      default: true,
      type: Boolean,
    },
    target: {
      default: "__blank",
      type: String,
    },
  },
  data() {
    return {
      isOpen: false,
      fieldSchema: null,
      form: {
        [this.field]: this.value,
      },
    };
  },
  computed: {
    isUpdateMode() {
      return this.mode === "update";
    },
    isText() {
      return this.type === "text";
    },
    isHtml() {
      return this.type === "html";
    },
    isLink() {
      return this.type === "url";
    },
    isMoney() {
      return this.type === "money";
    },
    isDate() {
      return this.type === "date";
    },
  },
  methods: {
    getFieldSchema() {
      this.$http
        .get(
          this.$laravel.route("api.property.statuses.get_field_details", {
            property: this.property.id,
            field: this.field,
          })
        )
        .then(response => {
          this.fieldSchema = response.data.data;
        });
    },
    openFieldModal() {
      this.$emit("click", {label: this.label, field: this.field, value: this.value});
    },

    closeModal() {
      this.isOpen = false;
    },
    fieldIs(type, field) {
      return type == field.component;
    },
    placeholder(field) {
      if (field.attributes.placeholder) {
        return field.attributes.placeholder.capitalize();
      }
      return field.label.capitalize();
    },
    onFormSuccess(response) {
      this.$emit("success", response);
      this.closeModal();
    },
    showLink (link)
    {
      if (!link) {
        return false;
      }

      return link.trim() !== "";
    }
  },
};
</script>
